import { AlertTriangle } from "lucide-react";

/** True when a card carries no equipped gear AND no consumables in its loadout. */
export const isBareOfGear = (card) =>
  !((card?.gear?.length || 0) + (card?.loadout?.length || 0));

/**
 * Prominent warning shown before entering PvC / Cavern / Dungeon with unarmed cards:
 * every difficulty basically requires gear — going in bare is choosing to forfeit a card.
 */
export function BareGearWarning({ names = [], context = "battle", className = "" }) {
  if (!names.length) return null;
  const list = names.join(", ");
  return (
    <div
      data-testid="bare-gear-warning"
      className={`rounded-lg border border-amber-400/40 bg-amber-400/10 p-3 ${className}`}
    >
      <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-amber-300 flex items-center gap-1.5">
        <AlertTriangle className="h-3.5 w-3.5 shrink-0" /> No gear = forfeit risk
      </div>
      <p className="text-[11px] text-amber-100/80 leading-relaxed mt-1.5">
        <span className="text-white font-medium">{list}</span> {names.length === 1 ? "has" : "have"} no gear or
        consumables equipped. Any difficulty of {context} basically requires gear — you can still go in, but
        entering without at least <span className="text-white font-medium">1 piece of gear or a consumable</span> is
        choosing to forfeit a card. Equip up in <span className="text-white font-medium">Adventure → Loadout</span> first.
      </p>
    </div>
  );
}
